import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/icons/arrows/arrows-arrow-left-s-fill/arrows-arrow-left-s-fill.component.js'

const tagName = 'dap-ds-icon-arrow-left-s-fill'

/**
 * `dap-ds-icon-arrow-left-s-fill`
 * @summary An icon
 * @element dap-ds-icon-arrow-left-s-fill
 * @title - ArrowsArrowLeftSFill
 * @group icon
 * @icontype arrows
 *
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'ArrowsArrowLeftSFill',
})

export default reactWrapper
